module.exports = __webpack_public_path__ + "resources/img/bg_banner_inquiry_m.fa155896ad4ae7c58252f60b7a4157e3.jpg";